import React from 'react'
import { FooterBottom } from '../'

export default () => (
  <footer>
    <FooterBottom />
  </footer>
)
